import { SubOption } from './suboption';
import { Adjustment } from './adjustment';
import { OptionIncludeExclude } from './option-include-exclude';
import { AdminOption } from './admin-option';
import { ProductLine } from './product-line';
import { DeselectedOption } from './deselected-option';


export class Option {
    public OptionId: number;
    public OptionNumber: number;
    public OptionDescription: string;
    public CategoryId: number;
    public CategoryDesc: string;
    public Commodity: number;
    public PartNumber: number;
    public UnitPrice: number;
    public TotalPrice: number;
    public StandardPrice: number;
    public SubOptions: SubOption[];
    public IncludeExclude: OptionIncludeExclude[];
    public StandardOption: boolean;
    public FrequencySequenceNumber: number;
    public FrequencySequenceCode: number;

    /// MyCustomHomes Stuff
    public AdjustedUnitPrice: string;            
    public AdjustedTotalPrice: number;
    public CustomUnitPrice: number;             
    public Quantity: number;
    public QuantityInfo: string;                
    public Note: string;
    public IsCustomPrice: boolean;
    public IsValidUnitPrice: boolean;
    public IsIncluded: boolean;
    public IsExcluded: boolean;
    public IncludePrice: boolean;
    public SelectedSubOptionDesc: string;
    public SelectedSubOption: number = -1;
    public ModifiedBy: string;
    public wasChanged: boolean;
    public InvalidSubOption: boolean;
    public UIUnitPrice: string;
    public UnitPriceOverride: number;
    public WasChanged: boolean;

    /// Options Admin Stuff
    public AdminOption: AdminOption;
    public PlantId: number;
    public PlantNumber: number;
    public SubOptionCount: number;
    public AdminOptionCount: number;
    public IncludeExcludeCount: number;
    public MaxQuantity: number;
    public Visible: boolean;
    public ProductLineId: number;
    public ProductLineDesc: string;
    public ProductLineCode: string;
    public AdminOptions: AdminOption[];
    public SelectItemForBulkChange: boolean;

	public HomeCategoryId: number;
	public HomeCategoryDescription: string;
	public AdminOptionsExist: boolean;

    public ProductLines: ProductLine[];

    constructor() {
        this.SubOptions = new Array<SubOption>();
        this.IncludeExclude = new Array<OptionIncludeExclude>();
        this.InvalidSubOption = false;
        this.UnitPriceOverride = null;
        this.ProductLines = new Array<ProductLine>();
        this.AdminOptions = new Array<AdminOption>();
        this.SelectItemForBulkChange = false;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/option.ts